import {useReducer} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {AutolinkerModel, ReferenceFormatModel} from '../../../models/api/autolinkerModel';
import {CustomFields} from '../commons/customFieldsModel';
import {StringOrTemplate} from '../commons/stringTemplateModel';
import {ExpressionStateActions, useExpressionState} from '../expressions/expressionState';
import {AutolinkerEditorActionTypesEnum} from './autolinkerEditorActions';
import {autolinkerEditorReducer} from './autolinkerEditorReducer';
import {AutolinkerEditorState} from './autolinkerEditorState';

export interface AutolinkerEditorStateActions extends ExpressionStateActions {
  onUpdateDescription: HandlerOf<string>;
  onUpdateReferenceFormat: HandlerOf<ReferenceFormatModel>;
  onUpdateUrlBuilder: HandlerOf<StringOrTemplate>;
}

export function useAutolinkerEditorState(
  initialAutolinker: AutolinkerModel | undefined,
  customFields: CustomFields,
): {autolinkerEditorState: AutolinkerEditorState} & AutolinkerEditorStateActions {
  const [autolinkerEditorState, dispatch] = useReducer(
    autolinkerEditorReducer,
    AutolinkerEditorState.createInitialState(initialAutolinker, customFields),
  );

  const onUpdateDescription = (description: string) => {
    dispatch({type: AutolinkerEditorActionTypesEnum.UPDATE_DESCRIPTION, description});
  };

  const onUpdateReferenceFormat = (referenceFormat: ReferenceFormatModel) => {
    dispatch({type: AutolinkerEditorActionTypesEnum.UPDATE_REFERENCE_FORMAT, referenceFormat});
  };

  const onUpdateUrlBuilder = (urlBuilder: StringOrTemplate) => {
    dispatch({type: AutolinkerEditorActionTypesEnum.UPDATE_URL_BUILDER, urlBuilder});
  };

  const expressionState = useExpressionState(
    {
      onAddExpressionValidator: undefined,
      makeOnDeleteExpressionValidator: undefined,
      makeOnAddAtomValidator: undefined,
      makeOnUpdateAtomValidator: undefined,
      makeOnDeleteAtomValidator: undefined,
    },
    autolinkerEditorState,
    dispatch,
  );

  return {
    autolinkerEditorState,

    onUpdateDescription,
    onUpdateReferenceFormat,
    onUpdateUrlBuilder,

    ...expressionState,
  };
}
